



















import { Component, Vue } from "vue-property-decorator";
import { version } from "@/config";

@Component
export default class Navigation extends Vue {
  open = false;
  version = version;

  get currentPath() {
    return this.$route.path;
  }

  toggleMenu() {
    this.open = !this.open;
  }
}
